module.exports = __webpack_public_path__ + "static/img/jx-3.4e527e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/jx-3.png
// module id = NFLU
// module chunks = 0